import { render } from "./BarAverageChart.vue?vue&type=template&id=239bf4cf"
import script from "./BarAverageChart.vue?vue&type=script&lang=js"
export * from "./BarAverageChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__